import { Component, HostBinding, Input, OnInit } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { formatModuleIconUrl } from 'src/util';

@Component({
  selector: 'app-module-icon',
  template: ``,
  styles: [],
})
export class ModuleIconComponent implements OnInit {
  readonly defaultSize: number = 26;
  @Input() icon!: string;
  @Input() color: 'black' | 'white' = 'black';
  @Input()
  size: number = this.defaultSize;

  @HostBinding('style') get style() {
    if (this.icon) {
      const url = formatModuleIconUrl(this.icon, this.color);
      const size = this.size || this.defaultSize;
      return this._san.bypassSecurityTrustStyle(this._formatCss(url, size));
    } else {
      return this._formatSizeCss(0);
    }
  }

  constructor(private _san: DomSanitizer) {}

  ngOnInit(): void {}

  private _formatCss(url: string, size: number) {
    return `${this._formatBackgroundCss(url)}${this._formatSizeCss(size)}`;
  }
  private _formatBackgroundCss(url: string) {
    return `
      background-image: url(${url});
      background-size: cover;
      background-repeat: no-repeat;
      `;
  }
  private _formatSizeCss(size: number) {
    size = size || 0;
    return `
    min-width: ${size}px;
    max-width: ${size}px;
    min-height: ${size}px;
    max-height: ${size}px;
    `;
  }
}
